import React from 'react'
import './Timeline.css'
import ReceivementCard from './ReceivementCard'
import AuditCard from './AuditCard'
import ProcessingCard from './ProcessingCard'
import BillingCard from './BillingCard'
import ReturnCard from './ReturnCard'
import ProductionCard from './ProductionCard'
import RunningCard from './RunningCard'
import OtherPlantsCard from './OtherPlantsCard'

const TimelineItem = ( data ) => {
    const getCard = (id) => {
        
        const type = {
            'Recebimento': <ReceivementCard data={data.data}></ReceivementCard>,
            'Faturamento': <BillingCard data={data.data}></BillingCard>,
            'Devolução': <ReturnCard data={data.data}></ReturnCard>,
            'Auditoria': <AuditCard data={data.data}></AuditCard>,
            'Beneficiamento': <ProcessingCard data={data.data}></ProcessingCard>,
            'Sonda': <RunningCard data={data.data}></RunningCard>,
            'Importação': <OtherPlantsCard data={data.data}></OtherPlantsCard>,

            
        }
        return type[id]
    }
    const content = <>
        {data.data.type === 'production' ?
         <ProductionCard data={data.data}></ProductionCard>
         :
         <div className="timeline-item">{getCard(data.data.type)}</div>
         }
    </>
  
    return content
}
export default TimelineItem